import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import { FavRowY } from '../components';

const List = styled.div`
  height: auto;
  overflow: scroll;
`;

const FavList = ({ theme, coins }) => (
  <ThemeProvider theme={theme}>
    <List>{coins.map(coin => <FavRowY coin={coin} key={coin.id} />)}</List>
  </ThemeProvider>
);

export default withTheme(FavList);



// WEBPACK FOOTER //
// ./src/components/FavListY.js